module.exports = __webpack_public_path__ + "static/media/team-member-03.81b85323.png";